import React from 'react';
import SectionQuote from './SectionQuote';

const CARDS = [
  {
    id: 'blueprint',
    rotation: -8,
    src: './blueprint.png',
    alt:
      'Blueprint-style concept art of an armored prototype character, annotated with system callouts.',
    caption:
      "A rough character concept - unknown, unreadable, but with huge potential. Sound familiar?",
  },
  {
    id: 'music',
    rotation: 0,
    src: './renoise_chipsynth.png',
    alt:
      'A chiptune pattern in progress across multiple tracks in the Renoise tracker.',
    caption:
      'Scoring it the old-fashioned way with a tracker and chip sounds to faithfully recreate the sounds we love.',
  },
  {
    id: 'tilemap',
    rotation: 8,
    src: './tilemapping.png',
    alt: 'A dev test stage being built tile by tile in the Tiled map editor.',
    caption:
      'Building a test stage tile by tile, until the platforming feels pixel perfect.',
  },
];

function Screenshots() {
  return (
    <section className="screenshots section" aria-label="Screenshots">
      <SectionQuote>Where did that energy come from??</SectionQuote>
      <div className="fan">
        {CARDS.map((card) => (
          <figure
            key={card.id}
            className="card"
            style={{ '--rot': `${card.rotation}deg` }}
            tabIndex={0}
          >
            <img
              className="card__image"
              src={card.src}
              alt={card.alt}
              loading="lazy"
            />
            <figcaption className="card__caption">{card.caption}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}

export default Screenshots;
